export const displayConstants = {
  DISPLAYDATA: 'DISPLAY_DATA',
};
